import { AxiosResponse } from 'axios'
import {
  AlterarSenhaCommand,
  AuthMfaResponse,
  AuthResponse,
  CanalDisponivel,
  DefinirSenhaCommand,
  EsqueciSenhaCommand,
  LoginQuery,
  ResetarSenhaCommand,
  SolicitarCodigoPrimeiroAcessoQuery,
  LoginPrimeiroAcessoQuery
} from 'src/types'
import api from '../../services/api'

export interface AlterarSenhaMasterCommand {
  CurrentPassword: string
  NewPassword: string
}

export function authLogin(
  query: LoginQuery
): Promise<AxiosResponse<AuthMfaResponse>> {
  return api.post('/auth/login', query)
}

export function solicitarCodigoPrimeiroAcesso(
  query: SolicitarCodigoPrimeiroAcessoQuery
): Promise<AxiosResponse> {
  return api.post('/auth/SolicitarCodigoPrimeiroAcesso', query)
}

export function loginPrimeiroAcesso(
  query: LoginPrimeiroAcessoQuery
): Promise<AxiosResponse<AuthResponse>> {
  return api.post('/auth/LoginPrimeiroAcesso', query)
}

export interface EnviarCodigoMfaCommand {
  token: string
  canalDisponivel: CanalDisponivel
}
export function enviarCodigoMFA(
  command: EnviarCodigoMfaCommand
): Promise<AxiosResponse<AuthMfaResponse>> {
  return api.post('/auth/EnviarCodigoMfa', command)
}

export interface ValidarCodigoMfaCommand {
  token: string
  codigo: string
}
export function validarCodigoMFA(
  command: ValidarCodigoMfaCommand
): Promise<AxiosResponse<AuthResponse>> {
  return api.post('/auth/ValidarCodigoMfa', command)
}

export function esqueciSenha(
  command: EsqueciSenhaCommand
): Promise<AxiosResponse> {
  return api.post('/auth/EsqueciSenha', command)
}

export function definirSenhaToken(
  command: DefinirSenhaCommand
): Promise<AxiosResponse> {
  return api.post('/auth/DefinirSenhaToken', command)
}

export function definirSenha(
  command: DefinirSenhaCommand
): Promise<AxiosResponse> {
  return api.post('/auth/DefinirSenha', command)
}

export const alterarSenha: (
  command: AlterarSenhaCommand
) => Promise<AxiosResponse<string | undefined>> = command => {
  const body: AlterarSenhaCommand = {
    senhaAtual: command.senhaAtual,
    novaSenha: command.novaSenha
  }
  return api.post('/auth/alterarSenha', body)
}

export const AlterarSenhaMaster: (
  command: AlterarSenhaMasterCommand
) => Promise<AxiosResponse<string | undefined>> = command => {
  const body: AlterarSenhaMasterCommand = {
    CurrentPassword: command.CurrentPassword,
    NewPassword: command.NewPassword
  }
  return api.post('/tenantpassword', body)
}

export function hasMasterPassword(): Promise<AxiosResponse<boolean>> {
  return api.get('/tenantpassword/exists')
}

export function aceitarTermoDeUso(tipoTermo: number): Promise<AxiosResponse> {
  return api.post(`/auth/aceitarTermo/${tipoTermo}`)
}

export function resetarSenha(
  command: ResetarSenhaCommand
): Promise<AxiosResponse> {
  return api.post('/auth/resetarsenha', command)
}

export interface ITenantResponse {
  id: string
  parceiroId: string
  localAtendimentoId: string
  uf: string
  descricao: string
  urlLogotipo: string
  horarioFuncionamento: string
  telefoneContato: string
  textoExclusao: string
}
export function obterTenant(): Promise<AxiosResponse<ITenantResponse>> {
  return api.get('/auth/tenant')
}

export async function gerarAuthCode() : Promise<string> {
  const response = await api.post('/auth/create-auth-code');
  var code = response.data as string;
  return code;
}
